import { render, staticRenderFns } from "./DisplayPhotoOverlay.vue?vue&type=template&id=68288d3e&"
import script from "./DisplayPhotoOverlay.vue?vue&type=script&lang=js&"
export * from "./DisplayPhotoOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports